import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const DiscoverComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "DiscoverSettingsPage" */ "@circle-react/components/SettingsApp/Discover"
    ),
);

export const DiscoverSettingsPage = () => (
  <Suspense fallback={<PageLoader />}>
    <DiscoverComponent />
  </Suspense>
);
